import Modal from '../ui/Modal';
import { useTranslation } from '@/i18n';

interface BenefitDeletionAlertModalProps {
  closeModal: () => void;
  actionOnClick: () => void;
  isMultiple?: boolean;
}

const BenefitDeletionAlertModal = ({
  closeModal,
  actionOnClick,
  isMultiple = false,
}: BenefitDeletionAlertModalProps) => {
  const { t } = useTranslation();

  const message = isMultiple
    ? t('modal.benefitDeletion.message.multiple')
    : t('modal.benefitDeletion.message.single');

  const title = isMultiple
    ? t('modal.benefitDeletion.title.multiple')
    : t('modal.benefitDeletion.title.single');

  return (
    <Modal
      closeModal={closeModal}
      actionOnClick={actionOnClick}
      title={title}
      actionTitle={t('modal.benefitDeletion.actionTitle')}
      message={message}
      specialColor="error"
    />
  );
};

export default BenefitDeletionAlertModal;
